import { Injectable } from '@angular/core';
import { confirm } from 'devextreme/ui/dialog';
import { AuthService } from '../auth.service';
import { ArkUnitOfWork } from './ark-unit-of-work';

@Injectable()
export class DocumentService {
    constructor(private uow: ArkUnitOfWork, private auth: AuthService) {}

    async deleteDocuments(documentIds: number[]) {
        if (!documentIds || documentIds.length === 0) return;
        const docs = await this.uow.committeeAttachments.byIds(documentIds, 'committeeAttachmentReviews');
        docs.forEach((doc) => {
            doc.deleted = new Date();
            doc.deletedBy = this.auth.currentUser.userName;
            // if (doc.committeeAttachmentReviews.length > 0) {
            //     doc.committeeAttachmentReviews.forEach((review) => {
            //         review.deleted = new Date();
            //         review.deletedBy = this.auth.currentUser.userName;
            //     });
            // }
        });
        await this.uow.commit();
    }
}
